import React, { useEffect, useState } from 'react';
import Dashboard from '../../../components/shared/dashboard/dashboard';
import MakeReservation from '../../../components/shared/make-reservation/make-reservation';
import { MakeReservationVariant } from '../../../components/shared/make-reservation/make-reservation.constants';
import { HandleReservationPageStyled } from './handle-reservation.page.styled';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  addAdminNoteAction,
  checkInOutEventReservationAction,
  confirmReservationAction,
  deleteReservationFromAdminAction,
  handleReservationAction,
  handleReservationPartialResetState,
  handleReservationResetState,
  updateIntervalPaymentStatusAction,
} from '../../../store/admin/handle-reservation.store';
import TableDetailReservation from './components/table-detail-reservation/table-detail-reservation';
import i18n from 'i18next';
import EventsListReservation from './components/events-list-reservation/events-list-reservation';
import {
  makeReservationResetState,
  setCustomerEventsAction,
} from '../../../store/shared/make-reservation.store';
import { useModal } from '../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../../../components/shared/modal-provider/components/modal/modal.constants';
import SendEmailModal from '../../../components/shared/send-email-modal/send-email-modal';
import {
  sendEmailAction,
  sendEmailResetState,
} from '../../../store/shared/send-email.store';
import HeaderReservation from './components/header-reservation/header-reservation';
import SearchTabReservation from './components/search-tab-reservation/search-tab-reservation';
import FooterBooking from '../../../components/shared/make-reservation/components/footer-booking/footer-booking';
import { getStringDateName } from '../../../utils/utils';

const HandleReservationPage = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const { openModal } = useModal();
  const [showMakeReservation, setShowMakeReservation] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState<any>(null);

  const {
    reservation,
    loading,
    error,
    confirmReservationSuccess,
    checkInOutEventSuccess,
    rooms,
    errorConfirmCheckInOutReservation,
    cancelReservationSuccess,
    addAdminNoteSuccess,
    updatePaymentStatusSuccess,
    errorPaymentStatus,
  } = useSelector((state: any) => {
    return state.handleReservation;
  });

  const { loadingEmail, errorEmail, sendEmailSuccess } = useSelector(
    (state: any) => {
      return state.sendEmail;
    },
  );

  const { loading: loadingMakeReservation, bookingSent, error : errorBooking } = useSelector(
    (state: any) => {
      return state.makeReservation;
    },
  );

  const handleConfirmReservation = (message: string) => {
    dispatch(
      confirmReservationAction({
        id: reservation.id,
        message: message,
      }),
    );
  };

  const handlePaymentStatus = (event: any) => {
    const dataToSend = {
      booking_id: event.booking.id,
      interval_id: event.id,
    };
    dispatch(updateIntervalPaymentStatusAction(dataToSend));
  };

  const handleAddAdminNotes = (message: string) => {
    dispatch(
      addAdminNoteAction({
        id: reservation.id,
        message: message,
      }),
    );
  };

  const handleCancelReservation = (message: string) => {
    dispatch(
      deleteReservationFromAdminAction({
        id: reservation.id,
        message: message,
      }),
    );
  };
  const onSendEmail = (message: string) => {
    dispatch(
      sendEmailAction({
        text: message,
        booking_id: reservation.id,
      }),
    );
    setShowEmailModal(false);
  };

  useEffect(() => {
    if (reservation) {
      dispatch(setCustomerEventsAction(reservation));
    }
  }, [reservation]);

  useEffect(() => {
    if (params?.id) {
      dispatch(makeReservationResetState());
      dispatch(handleReservationAction(params.id));
    } else {
      dispatch(handleReservationResetState());
    }
  }, [params]);

  useEffect(() => {
    if (bookingSent) {
      dispatch(handleReservationAction(reservation.id));
      setShowMakeReservation(false);
    }
  }, [bookingSent]);

  useEffect(() => {
    if (error || errorConfirmCheckInOutReservation) {
      openModal({
        message: error || errorConfirmCheckInOutReservation,
        variant: ModalVariant.Error,
      });
      dispatch(handleReservationPartialResetState());
    }
    if (errorEmail) {
      openModal({
        message: errorEmail,
        variant: ModalVariant.Error,
      });
      dispatch(sendEmailResetState());
    }
  }, [
    error,
    errorConfirmCheckInOutReservation,
    errorEmail,
  ]);

  useEffect(() => {
    if (errorPaymentStatus) {
      openModal({
        message: errorPaymentStatus,
        variant: ModalVariant.Error,
        handleCloseModal: () => {
          dispatch(handleReservationPartialResetState());
        },
      });
    }
  }, [errorPaymentStatus]);

  useEffect(() => {
    if (errorBooking) {
      setShowMakeReservation(false)
      dispatch(makeReservationResetState());
      dispatch(handleReservationAction(reservation.id));
    }
  }, [errorBooking]);

  useEffect(() => {
    if (
      checkInOutEventSuccess ||
      confirmReservationSuccess ||
      cancelReservationSuccess ||
      addAdminNoteSuccess
    ) {
      let message = checkInOutEventSuccess
        ? i18n.t('handleReservation.checkInOutSuccess', {
            type: checkInOutEventSuccess,
          })
        : i18n.t('handleReservation.successConfirmMessage');
      cancelReservationSuccess &&
        (message = i18n.t('handleReservation.successCancelReservationMessage'));
      addAdminNoteSuccess &&
        (message = i18n.t('handleReservation.adminNotesSuccess'));
      setShowMakeReservation(false);
      openModal({
        message: message,
        variant: ModalVariant.Success,
      });
      dispatch(makeReservationResetState());
      dispatch(handleReservationAction(reservation.id));
    }
  }, [
    checkInOutEventSuccess,
    confirmReservationSuccess,
    cancelReservationSuccess,
    addAdminNoteSuccess,
  ]);

  useEffect(() => {
    if (sendEmailSuccess) {
      openModal({
        message: i18n.t('sendEmail.emailSuccessMessage'),
        variant: ModalVariant.Success,
        handleCloseModal: () => dispatch(sendEmailResetState()),
      });
    }
  }, [sendEmailSuccess]);

  useEffect(() => {
    if (updatePaymentStatusSuccess) {
      openModal({
        message: i18n.t('handleReservation.paymentStatusSuccess'),
        variant: ModalVariant.Success,
        handleCloseModal: () =>
          dispatch(handleReservationAction(reservation.id)),
      });
      dispatch(handleReservationPartialResetState());
    }
  }, [updatePaymentStatusSuccess]);

  return (
    <Dashboard callingPage={'HandleReservationAdminPage'}>
      <HandleReservationPageStyled.Container>
        {reservation && (
          <HeaderReservation
            reservation={reservation}
            handleCancelReservation={handleCancelReservation}
            onSearchClick={() => {
              dispatch(makeReservationResetState());
              dispatch(handleReservationResetState());
            }}
          />
        )}
        {!reservation && (
          <SearchTabReservation
            onSearchClick={(id: string) =>
              dispatch(handleReservationAction(id))
            }
          />
        )}
        {reservation && (
          <>
            {!showMakeReservation && (
              <TableDetailReservation
                handleAddAdminNotes={handleAddAdminNotes}
                reservation={reservation}
                setShowMakeReservation={setShowMakeReservation}
                loading={loading || loadingEmail}
                onClickEmail={(selectedReservation: any) => {
                  setShowEmailModal(true);
                  setSelectedReservation(selectedReservation);
                }}
              />
            )}
            {showMakeReservation && !loadingMakeReservation && (
              <HandleReservationPageStyled.DetailsContainer>
                <HandleReservationPageStyled.FieldDetailContainer>
                  <HandleReservationPageStyled.FieldDetailLabel>
                    {i18n.t('handleReservation.reservationIdLabel')}
                  </HandleReservationPageStyled.FieldDetailLabel>
                  <HandleReservationPageStyled.FieldDetailValue>
                    {reservation.reference_number ? reservation.reference_number : reservation.id}
                  </HandleReservationPageStyled.FieldDetailValue>
                </HandleReservationPageStyled.FieldDetailContainer>
                <HandleReservationPageStyled.FieldDetailContainer>
                  <HandleReservationPageStyled.FieldDetailLabel>
                    {i18n.t('handleReservation.reservationDateLabel')}
                  </HandleReservationPageStyled.FieldDetailLabel>
                  <HandleReservationPageStyled.FieldDetailValue>
                    {getStringDateName(reservation.created_at)}
                  </HandleReservationPageStyled.FieldDetailValue>
                </HandleReservationPageStyled.FieldDetailContainer>
              </HandleReservationPageStyled.DetailsContainer>
            )}
            {showMakeReservation && (
              <MakeReservation
                closeCalendar={() => {
                  setShowMakeReservation(false);
                  dispatch(setCustomerEventsAction(reservation));
                }}
                variant={MakeReservationVariant.AdminHandleReservation}
              />
            )}
            {!showMakeReservation && (
              <EventsListReservation
                loading={loading}
                onPaymentStatusChange={item => handlePaymentStatus(item)}
                reservation={reservation}
                rooms={rooms}
                onCheckInOutClick={(data: any) =>
                  dispatch(checkInOutEventReservationAction(data))
                }
                onEditReservationClick={() => setShowMakeReservation(true)}
              />
            )}
            {!showMakeReservation && reservation.status === 'SENT' && (
              <FooterBooking
                buttonText={i18n.t('handleReservation.confirmReservation')}
                onClickButton={() => {
                  openModal({
                    message: i18n.t(
                      'handleReservation.confirmReservationWarning',
                    ),
                    variant: ModalVariant.WarningTextPicker,
                    onConfirmClick: handleConfirmReservation,
                  });
                }}
              />
            )}
          </>
        )}
        <SendEmailModal
          isVisible={showEmailModal}
          onModalClose={() => {
            setShowEmailModal(false);
            setSelectedReservation(null);
          }}
          selectedReservation={selectedReservation}
          onSendEmail={(message: string) => onSendEmail(message)}
        />
      </HandleReservationPageStyled.Container>
    </Dashboard>
  );
};

export default HandleReservationPage;
